export default {"src":"/_next/static/media/weather-icon.8d4e9ecf.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};